import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const CAGRCalculator = () => {
    const [initialInvestment, setInitialInvestment] = useState(1000);
    const [finalInvestment, setFinalInvestment] = useState(2000);
    const [duration, setDuration] = useState(5);
    const [cagr, setCagr] = useState(0);

    useEffect(() => {
        calculateCAGR(initialInvestment, finalInvestment, duration);
    }, [initialInvestment, finalInvestment, duration]);

    const calculateCAGR = (initial, final, years) => {
        if (initial > 0 && final > 0 && years > 0) {
            const cagrValue = ((final / initial) ** (1 / years) - 1) * 100;
            setCagr(cagrValue.toFixed(2));
        } else {
            setCagr(0);
        }
    };

    const handleReset = () => {
        setInitialInvestment(1000);
        setFinalInvestment(2000);
        setDuration(5);
    };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            question: 'What is the full form of CAGR?',
            answer: 'CAGR stands for Compound Annual Growth Rate. It is a measure of the growth of an investment over time with compounded returns.',
          },
          {
            question: 'How does CAGR differ from simple return?',
            answer: 'Unlike simple return, which calculates the total return over the period, CAGR provides the annualized rate of return, assuming consistent year-on-year growth.',
          },
          {
            question: 'Is CAGR always a reliable indicator of investment growth?',
            answer: 'While CAGR gives a good overall view of performance, it does not reflect market volatility or risk. It’s best used in combination with other metrics.',
          },
          {
            question: 'Can I calculate CAGR for any investment?',
            answer: 'Yes, CAGR can be calculated for any investment, including stocks, mutual funds, real estate, business revenue, and more.',
          },
          {
            question: 'What if my investment grows at different rates each year?',
            answer: 'CAGR assumes constant annual growth. If your investment has fluctuating growth rates, CAGR provides a smoothed average and may not capture actual yearly performance.',
          },
          {
            question: 'How do I interpret a negative CAGR?',
            answer: 'A negative CAGR indicates that the investment has declined in value over the time period, reflecting a compounded annual loss.',
          },
          {
            question: 'Can I use CAGR for comparing businesses?',
            answer: 'Yes, CAGR is a widely used tool to compare the growth rates of different businesses, revenue streams, or product lines over a defined time frame.',
          },
          {
            question: 'What is a good CAGR?',
            answer: 'A good CAGR depends on the type of investment and market context. Generally, a higher CAGR signals stronger performance, but risk should also be considered.',
          },
          {
            question: 'Does CAGR consider dividends or interest?',
            answer: 'No, the basic CAGR formula only considers the principal growth. It does not include returns from dividends or interest unless they are reinvested and factored into the final value.',
          },
          {
            question: 'Can I use CAGR for short-term investments?',
            answer: 'Yes, although CAGR is more meaningful for long-term analysis, it can be applied to short-term investments to understand annualized growth rates.',
          },
          {
            question: 'Is CAGR suitable for all types of investments?',
            answer: 'CAGR is best suited for investments with relatively steady growth over time. It may not fully capture the performance of highly volatile or speculative assets.',
          },
          {
            question: 'How does CAGR impact my investment decisions?',
            answer: 'CAGR helps you evaluate how consistently an investment has grown annually, making it easier to compare against your financial goals or other assets.',
          },
          {
            question: 'Is CAGR different from the average return?',
            answer: 'Yes. CAGR is a geometric mean that accounts for compounding, while average return is an arithmetic mean that doesn’t consider year-over-year effects.',
          },
          {
            question: 'Does CAGR account for inflation?',
            answer: 'No, CAGR reflects nominal returns. To understand the real return, you must subtract the average inflation rate from the CAGR.',
          },
          {
            question: 'Can I calculate CAGR for business revenue?',
            answer: 'Yes, CAGR is commonly used to assess business metrics like annual revenue, profit, or customer base growth over a specific period.',
          },
        ];
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
    return (
        <>
         <Helmet>
         <title>CAGR Calculator: Calculate Compound Annual Growth Rate Online | TheFinmaster</title>
        <meta  name='description' content='Use online CAGR Calculator to calculate the compound annual growth rate for your investment over a certain time period. | TheFinmaster'/>
        <meta name='keywords' content='sip cagr calculator, compound annual growth rate calculator, compound average growth rate calculator, cumulative annual growth rate calculator' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/cagr-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">CAGR Calculator</span>
        </li> 
      
      </ol>
    </nav>
            <div className='py-4'>


                <div className="container mx-auto p-4 max-w-8xl">
                    <div className="flex flex-wrap -mx-4">
                        <div className="w-full lg:w-2/3 px-4">
                            <h1 className="text-2xl font-bold mb-4">CAGR Calculator</h1>
                            <div className="bg-white shadow-md rounded p-6">
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-semibold">Initial investment</label>
                                    <div className="flex items-center">
                                        <input
                                            type="number"
                                            value={initialInvestment}
                                            onChange={(e) => setInitialInvestment(Number(e.target.value))}
                                            className="w-1/2 p-2 border rounded mr-2"
                                        />
                                        <span className="text-gray-700">₹ {initialInvestment.toLocaleString()}</span>
                                    </div>
                                    <input
                                        type="range"
                                        min="1000"
                                        max="1000000"
                                        value={initialInvestment}
                                        onChange={(e) => setInitialInvestment(Number(e.target.value))}
                                        className="w-full mt-2"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-semibold">Final investment</label>
                                    <div className="flex items-center">
                                        <input
                                            type="number"
                                            value={finalInvestment}
                                            onChange={(e) => setFinalInvestment(Number(e.target.value))}
                                            className="w-1/2 p-2 border rounded mr-2"
                                        />
                                        <span className="text-gray-700">₹ {finalInvestment.toLocaleString()}</span>
                                    </div>
                                    <input
                                        type="range"
                                        min="1000"
                                        max="10000000"
                                        value={finalInvestment}
                                        onChange={(e) => setFinalInvestment(Number(e.target.value))}
                                        className="w-full mt-2"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-semibold">Duration of investment (years)</label>
                                    <div className="flex items-center">
                                        <input
                                            type="number"
                                            min="1"
                                            max="30"
                                            value={duration}
                                            onChange={(e) => setDuration(Number(e.target.value))}
                                            className="w-1/2 p-2 border rounded mr-2"
                                        />
                                        <span className="text-gray-700">{duration} Yr</span>
                                    </div>
                                    <input
                                        type="range"
                                        min="1"
                                        max="30"
                                        value={duration}
                                        onChange={(e) => setDuration(Number(e.target.value))}
                                        className="w-full mt-2"
                                    />
                                </div>
                                <div className="mt-4 bg-green-100 p-4 rounded">
                                    <span className="font-semibold text-gray-700">CAGR is:</span>
                                    <span className="text-xl font-bold text-gray-900"> {cagr}%</span>
                                </div>
                                <div className="mt-4">
                                    <button
                                        className="bg-green-500 text-white px-4 py-2 rounded"
                                        onClick={handleReset}
                                    >
                                        RESET
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="w-full lg:w-1/3 px-4 mt-8 lg:mt-0 text-center">
                            <div className="bg-white shadow-md rounded p-6">
                                <h2 className="text-xl font-bold mb-4">Invest the way you want</h2>
                                <div className="mb-4">
                                    <img src="https://www.shutterstock.com/image-illustration/credit-cards-online-shopping-banner-260nw-355524626.jpg" alt="Banner" className="w-full rounded" />
                                </div>
                                <p>Join millions of Indians who trust and love TheFinMaster.</p>
                                <button className="bg-green-500 text-white px-4 py-2 rounded mt-4">Explore Products</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="flex flex-wrap  lg:px-6 md:px-6 px-0 py-6" >
            <div className="w-full md:w-2/3 p-4 mx-auto">
            <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            What is CAGR (Compound Annual Growth Rate)?
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            CAGR stands for Compound Annual Growth Rate, a crucial metric that helps measure the growth of an investment over a specific period, assuming that the investment grows at a steady rate. CAGR is often used to evaluate the performance of businesses, stocks, mutual funds, or any other investment over time. Unlike simple returns that provide absolute figures, CAGR reflects the actual annualized growth rate that would result in the same final value as the one observed, assuming constant growth.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            CAGR is especially useful in evaluating investment performance because it smoothens out the volatility and fluctuations in the value of investments. By using CAGR, you can compare the performance of different investments or benchmark your returns against industry standards. Essentially, CAGR helps you identify the true potential of your investment by providing an annualized return rate that incorporates the compounding effect.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why is CAGR Important?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              CAGR helps to analyze long-term investments by considering the time factor. When investing, the time period during which the investment grows plays a significant role in determining its final value. CAGR is used to evaluate the real return of investments, especially over multi-year periods. Unlike one-time returns, CAGR gives a more accurate and comparable figure over time. It’s especially useful in assessing investments with fluctuating returns such as stock portfolios, mutual funds, or business growth projections.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The growth rate of an investment, regardless of its volatility, can be better understood by CAGR, which reflects the growth in a consistent manner.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the CAGR Calculator Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The CAGR Calculator is a financial tool that helps you compute the Compound Annual Growth Rate of any investment over a given time period. It works by taking three key inputs:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Initial Investment (Present Value, PV):</strong> The amount of money initially invested or the value of the asset at the beginning of the investment period.</li>
              <li><strong>Final Value (Future Value, FV):</strong> The value of the investment at the end of the investment period.</li>
              <li><strong>Time Period (n):</strong> The number of years over which the investment has grown.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using these three variables, the CAGR calculator computes the average annual return over the time period, assuming that the returns are compounded over time.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Formula for Calculating CAGR:</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The CAGR formula is:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              CAGR = (FV / PV) ^ (1 / n) - 1
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>FV is the Future Value (the value of the investment at the end of the investment period).</li>
              <li>PV is the Present Value (the value of the investment at the start).</li>
              <li>n is the number of years over which the growth is calculated.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This formula is powerful because it condenses the complex process of measuring compounded growth into a single percentage figure.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Benefits of Using a CAGR Calculator
            </h1>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Unveiling Hidden Insights</strong><br />Unlike simple returns, which only show the total return from the investment, CAGR offers a more insightful look into how your investment has grown over time. It eliminates the noise created by short-term market fluctuations and provides a smoother picture of how your investment has progressed.<br />CAGR gives you a detailed view of how your investment grows year after year, assuming the growth occurs at a constant rate. This makes it easier to track the performance of different investments over similar periods.</li>
              <li><strong>Standardized Growth Comparison</strong><br />CAGR is a great tool for comparing the growth of different investments or business units. It helps standardize growth rates by assuming that the growth is compounded yearly at a consistent rate. For instance, if you’re evaluating two mutual funds, CAGR helps you to understand which one offers a better annualized return.<br />It can be used to compare diverse assets such as stocks, bonds, mutual funds, and business performance over time.</li>
              <li><strong>Calculates True Annual Returns</strong><br />The true measure of investment performance is how much an investment grows annually. A CAGR calculator helps to reveal the real annual return on your investment. The figure provided by the calculator represents the true rate of return you could expect if the investment had grown at a consistent rate.</li>
              <li><strong>Saves Time and Effort</strong><br />Calculating CAGR manually can be a tedious process, especially when working with a series of investments or complex portfolios. Using a CAGR calculator simplifies this process, providing accurate results instantly. This saves you time and ensures that you can focus on other aspects of your financial planning.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Key Insights Revealed by CAGR
            </h1>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Investment Performance</strong><br />CAGR gives you a precise measure of how well your investments have been performing over a specified period. Whether it’s stocks, bonds, mutual funds, or even business revenue, CAGR reveals the actual rate of growth and helps you understand the annualized return on investment.</li>
              <li><strong>Growth Trajectory of a Business</strong><br />For business owners, understanding the CAGR of revenue or profits can be a valuable tool. By calculating CAGR for a specific metric (like annual revenue), you can analyze whether the business is growing steadily, stagnating, or declining. CAGR helps identify if reinvestment strategies are effective and can guide future decision-making processes.</li>
              <li><strong>Investment Evaluation and Comparisons</strong><br />When evaluating different investment opportunities, CAGR helps you compare potential returns. For instance, if you're comparing two stocks, one with a CAGR of 10% and another with a CAGR of 15%, you can confidently make a more informed decision. CAGR allows you to adjust your expectations for the future based on the historical growth rate of each investment.</li>
              <li><strong>Benchmarking Against Competitors</strong><br />CAGR also allows you to benchmark your business growth against industry leaders. By comparing your growth rate with others in your sector, you can identify areas of opportunity for improvement. Understanding competitor CAGR rates also helps in strategic planning, allowing you to adjust your business strategies accordingly.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How to Use the CAGR Calculator
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The CAGR Calculator on TheFinMaster is an easy-to-use tool designed for your convenience. To use the calculator, follow these steps:
            </p>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Enter the Present Value (PV):</strong> Start by entering the initial value of your investment or business at the beginning of the specified time period.</li>
              <li><strong>Enter the Future Value (FV):</strong> Input the value of your investment or business at the end of the specified time period.</li>
              <li><strong>Enter the Time Period (n):</strong> Specify the number of years over which the investment or business has grown.</li>
              <li><strong>Get the Results:</strong> The calculator will immediately calculate and display the annual growth rate (CAGR) as a percentage.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator helps you track your business’s or investment's progress over time and provides a clear overview of its growth potential.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Important Considerations When Using a CAGR Calculator
            </h1>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>CAGR Does Not Account for Risk</strong><br />While CAGR gives a precise estimate of growth, it does not account for the volatility or risk associated with the investment. It assumes a constant rate of growth, which is often not the case in real-world scenarios. Therefore, while CAGR provides a valuable growth figure, it should not be the sole factor in making investment decisions.</li>
              <li><strong>Time Period Sensitivity</strong><br />The results from the CAGR formula are highly sensitive to the length of the investment period. A short-term investment may show misleading results if only a few years of data are used. On the other hand, a longer time frame will provide a more stable growth estimate. It's essential to ensure that the period selected reflects the true nature of the investment or business.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Interpreting the Results of the CAGR Calculator
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Once you input your values into the CAGR calculator, it will provide you with a single percentage figure that represents your investment’s annualized return rate. Here’s how to interpret the result:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Higher CAGR:</strong> A higher CAGR indicates a stronger performance. For instance, a 15% CAGR means your investment has been growing at an annual rate of 15%, compounded each year.</li>
              <li><strong>Lower CAGR:</strong> A lower CAGR indicates weaker performance. It could suggest that the investment has underperformed compared to other opportunities.</li>
              <li><strong>Negative CAGR:</strong> A negative CAGR indicates that your investment has declined over the investment period.</li>
            </ul>
          </div>
        </div>

                <div className="w-full md:w-1/3 p-4">
                    <div className="bg-white shadow-md rounded-lg overflow-hidden">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
                            <h2 className="text-lg font-semibold ">Popular Categories</h2>
                        </div>
                        <div className="p-2 ">
                        <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
                                {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                </div>

            </div>

            <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default CAGRCalculator;
